import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import buffer from 'buffer'
(window as any).Buffer = buffer.Buffer
import React from 'react'
import ReactDOM from 'react-dom'
import './polyfills'
import './app.css'

import Router from './router'
import routes from './router/routes'
import Store from './store'

const initialState: Record<string, any> = (window as any).__INITIAL_STATE__ || {}

const router = Router(routes)
const store = Store({
  router,
  initialState,
})

const rootEl = document.querySelector('#root')

let render = () => {
  const RootAppComponent = require('./root').default
  ReactDOM.render(
    <RootAppComponent
      store={ store }
      router={ router }
    />,
    rootEl
  )
}

render()
